import { Vue, Component, Prop } from 'vue-property-decorator';
import * as mws from '@/shared/MwsViewModels';
import template from './event-info-element.vue';

@Component({
  mixins: [template],
})
export default class EventInfoElement extends Vue {
  @Prop()
  data!: mws.EventInfoElement;
}
